let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Rpg4")).then(() => parcelRequire('9ryJx'));